import {tokenDefinition} from '../../token/tokenDefinition.mjs';
import {TokenType} from '../../token/tokenType.mjs';

const TokenName = Object.freeze({
    LINE_FEED: 'COURSE_LINE_FEED',
    UNIT_TITLE: 'COURSE_UNIT_TITLE',
    PAGE_NAME: 'COURSE_PAGE_NAME',
    SPACE: 'COURSE_SPACE',
});

const defineToken = (name, type, matcher) => tokenDefinition({
    name,
    type,
    tokenMatcher: matcher,
    contentMatcher: matcher,
});

const lineFeed = defineToken(TokenName.LINE_FEED, TokenType.DELIMITER, /^\r?\n/);
const unitTitle = defineToken(TokenName.UNIT_TITLE, TokenType.KEYWORD, /^[\t ]*#(?:[\t ]+|(?=\r?\n|$))/);
const pageName = defineToken(TokenName.PAGE_NAME, TokenType.KEYWORD, /^[\t ]*##(?:[\t ]+|(?=\r?\n|$))/);
const space = defineToken(TokenName.SPACE, TokenType.DELIMITER, /^[\t ]+/);

const tokenDefinitions = Object.freeze([lineFeed, unitTitle, pageName, space]);

export {TokenName, lineFeed, unitTitle, pageName, space, tokenDefinitions};
